<app-page-header title="Home" description="An overview of notifications and warnings across your active promotions."></app-page-header>
<div class="dashboard-body container">
  <div class="info-cards">
    @for (card of infoCards; track card.title) {
      <!-- Info Cards -->
      @if (card.type === 'info') {
        <app-custom-card>
          <div card-icon><i class="info dx-icon-info"></i></div>
          <div card-header>{{card.title}} <br><b>{{card.info}}</b></div>
        </app-custom-card>
      }
      <!-- Warning Cards -->
      @if (card.type === 'warning') {
        <app-custom-card>
          <div card-icon><i class="warning dx-icon-warning"></i></div>
          <div card-header><b>{{card.info}}</b> <br> {{card.title}}</div>
        </app-custom-card>
      }
      <!-- Error Cards -->
      @if (card.type === 'error') {
        <app-custom-card>
          <div card-icon><i class="error dx-icon-info"></i></div>
          <div card-header><b>{{card.info}}</b> <br>{{card.title}}</div>
        </app-custom-card>
      }
    }
  </div>
  <div class="dashboard-logo">
  </div>
  <div class="version">{{version}}</div>
</div>
